import moment from 'moment';
import TrimmedUser from './TrimmedUser';

class Comment {
  constructor({
    _id = null,
    wod = null,
    createdAt = null,
    // eslint-disable-next-line
    author: {
      user: userAuthor = {},
      name: authorName = '',
    } = {},
    text = '',
    comments = [],
  }) {
    this.id = _id;
    this.wod = wod;
    this.createdAt = createdAt ? moment(createdAt) : null;
    this.author = {
      user: userAuthor ? new TrimmedUser(userAuthor) : null,
      name: authorName,
    };
    this.text = text;
    this.comments = comments;
  }
}

export default Comment;
